/*
================================================================================
File: src/constants/stopLightClasses.js
Description: Defines constants for different views/pages in the application.
================================================================================
*/
  export const getWholeSaleLabelClasses = (EQP, listingIsNotGreen) => {
    if (EQP > 0.35) {
      return listingIsNotGreen
        ? "bg-yellow-300 text-black dark:bg-yellow-800"
        : "bg-green-500 text-white dark:bg-green-800";
    } else if (EQP > 0.3) {
      return "bg-yellow-300 text-black dark:bg-yellow-800";
    }
    return "bg-red-500 text-white dark:bg-red-800";
  };

  export const getEquityPartnerLabelClasses = (EQP, listingIsNotGreen) => {
    if (EQP > 0.35) {
      return listingIsNotGreen
        ? "bg-yellow-300 text-black dark:bg-yellow-800"
        : "bg-green-500 text-white dark:bg-green-800";
    } else if (EQP > 0.3) {
      return "bg-yellow-300 text-black dark:bg-yellow-800";
    }
    return "bg-red-500 text-white dark:bg-red-800";
  };

  export const getShortSaleLabelClasses = (EQP, Lo1C, listingIsNotGreen) => {
    if ((EQP < 0.1 && Lo1C) || EQP < 0.01) {
      return listingIsNotGreen
        ? "bg-yellow-300 text-black dark:bg-yellow-800"
        : "bg-green-500 text-white dark:bg-green-800";
    } else if (EQP < 0.08) {
      return "bg-yellow-300 text-black dark:bg-yellow-800";
    }
    return "bg-red-500 text-white dark:bg-red-800";
  };

  export const getFixFlipLabelClasses = (EQP, listingIsNotGreen) => {
    if (EQP > 0.25) {
      return listingIsNotGreen
        ? "bg-yellow-300 text-black dark:bg-yellow-800"
        : "bg-green-500 text-white dark:bg-green-800";
    } else if (EQP > 0.2) {
      return "bg-yellow-300 text-black dark:bg-yellow-800";
    }
    return "bg-red-500 text-white dark:bg-red-800";
  };

  export const getFlipOnWrapLabelClasses = (EQP, listingIsNotGreen) => {
    if (EQP > 0.25) {
      return listingIsNotGreen
        ? "bg-yellow-300 text-black dark:bg-yellow-800"
        : "bg-green-500 text-white dark:bg-green-800";
    } else if (EQP > 0.2) {
      return "bg-yellow-300 text-black dark:bg-yellow-800";
    }
    return "bg-red-500 text-white dark:bg-red-800";
  };

  export const getMortAssignLabelClasses = (EQP, Lo1C, listingIsNotGreen, ARV, debt, repairs) => {
    if ((EQP > 0.3 || (EQP > 0 && Lo1C)) && debt > 0.5 * ARV) {
      return listingIsNotGreen || repairs > 0.1 * ARV
        ? "bg-yellow-300 text-black dark:bg-yellow-800"
        : "bg-green-500 text-white dark:bg-green-800";
    } else if ((EQP > -0.05 || (EQP > -0.15 && Lo1C)) && debt > 0.5 * ARV) {
      return "bg-yellow-300 text-black dark:bg-yellow-800";
    }
    return "bg-red-500 text-white dark:bg-red-800";
  };

  export const getBuyHoldLabelClasses = (EQP, listingIsNotGreen) => {
    if (EQP > 0.2) {
      return listingIsNotGreen
        ? "bg-yellow-300 text-black dark:bg-yellow-800"
        : "bg-green-500 text-white dark:bg-green-800";
    } else if (EQP > 0.1) {
      return "bg-yellow-300 text-black dark:bg-yellow-800";
    }
    return "bg-red-500 text-white dark:bg-red-800";
  };

  export const getListingLabelClasses = (needsale, listed, valueNetProceedsRetail) => {
    if (
      needsale >= 6 &&
      needsale <= 29 &&
      listed === "0" &&
      valueNetProceedsRetail >= 0
    ) {
      return "bg-green-500 text-white dark:bg-green-800";
    } else if (valueNetProceedsRetail > 0) {
      return "bg-yellow-300 text-black dark:bg-yellow-800";
    }
    return "bg-red-500 text-white dark:bg-red-800";
  };

  export const getLeaseOptionLabelClasses = (state, EQP, Lo1C, listingIsNotGreen) => {
    if (state === "TX") {
      return "bg-yellow-300 text-black dark:bg-yellow-800";
    }
    if (EQP >= 0.1 && Lo1C) {
      if (!listingIsNotGreen) {
        return "bg-yellow-300 text-black dark:bg-yellow-800";
      } else if (EQP > -0.05 && Lo1C) {
        return "bg-yellow-300 text-black dark:bg-yellow-800";
      }
    return "bg-red-500 text-white dark:bg-red-800";
    }
    return "bg-red-500 text-white dark:bg-red-800";
  };

  export const getAuctionOptionLabelClasses = (EQP, listingIsNotGreen) => {
    if (EQP >= 0.3) {
      if (!listingIsNotGreen) {
        return "bg-yellow-300 text-black dark:bg-yellow-800";
      } else if (EQP >= 0.15) {
        return "bg-yellow-300 text-black dark:bg-yellow-800";
      }
    return "bg-red-500 text-white dark:bg-red-800";
    }
    return "bg-red-500 text-white dark:bg-red-800";
  };

  export const getHouseSwapLabelClasses = (EQP, needHome, listingIsNotGreen) => {
    if (EQP >= 0.2 && needHome === "1") {
      return !listingIsNotGreen
        ? "bg-yellow-300 text-black dark:bg-yellow-800"
        : "bg-green-500 text-white dark:bg-green-800";
    } else if (EQP > 0.05 && needHome === "1") {
      return "bg-yellow-300 text-black dark:bg-yellow-800";
    }
    return "bg-red-500 text-white dark:bg-red-800";
  };

  export const getContractDeedLabelClasses = (isCommercial, EQP, listingIsNotGreen) => {
    if (isCommercial && EQP > 0.15) {
      return !listingIsNotGreen
        ? "bg-yellow-300 text-black dark:bg-yellow-800"
        : "bg-green-500 text-white dark:bg-green-800";
    } else if (isCommercial && EQP < 0.15) {
      return "bg-yellow-300 text-black dark:bg-yellow-800";
    }
    return "bg-red-500 text-white dark:bg-red-800";
  };
